type ValidationError = {
    value?: string
}

const ValidationError = (props: ValidationError) => {
    return (
        <div role='alert' className={'input-validation-message'}>
            {props.value}
        </div>
    )
}

export default ValidationError